
/* injects from baggage-loader */

'use strict';

export default class AccountProfileController {

	constructor($log, $state, UsStates, Countries) {
		'ngInject';

		this.heading = 'Investor Profile';

		this.$log = $log;
		this.$state = $state;
		this.usStates = UsStates;
		this.countries = Countries;

	}

	$onInit() {
		this.$log.log(this.profile);
	}

	cancel() {

		// Revert object changes
		this.profile.revert();

		// Return to account home
		this.$state.go('account.home');
		
	}

	save() {

		// Save the profile
		this.profile.save()
			.then(profile => {
				alert('Profile updated!');

				// Return to account home
				this.$state.go('account.home');

			});

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/profile/account.profile.controller.js